<template>
    <el-form :inline="true" class="mainSearch">
      <el-page-header @back="goback" style="margin-bottom: 20px">
        <template #content>
          <span class="text-large font-600 mr-3">{{ title }} </span>
        </template>
      </el-page-header>
    </el-form>
    <el-row class="mainTableBox">
      <el-col :span="24" class="mpadding">
        <el-descriptions title="客户基本信息" :column="2">
          
          <el-descriptions-item label="客户名称"
            ><span v-text="customerInfo.name"></span
          ></el-descriptions-item>
          <el-descriptions-item label="客户类型">
            <el-tag round type="danger" disable-transitions
              ><span v-text="util.showCustomerType(customerInfo.customertype)"></span>
            </el-tag>
          </el-descriptions-item>
          <!-- <el-descriptions-item label="结算方式">
            <el-tag round type="success" disable-transitions
              ><span v-text="util.showBalanceway(customerInfo.balanceway)"></span>
            </el-tag>
          </el-descriptions-item> -->
          <el-descriptions-item label="收款方式">
            <el-tag round type="success" disable-transitions
              ><span v-text="util.showPaidWay(customerInfo.paidway)"></span>
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="收款账户">
            <el-tag size="small"
              ><span v-text="customerInfo.paidaccount"></span
            ></el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="毛利率区间">
            <el-tag size="small"><span v-text="customerInfo.maoliv"></span>-<span v-text="customerInfo.maolivge"></span></el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="有无合同"
            ><el-tag round type="warning" disable-transitions
              ><span
                v-text="util.showYesNo(customerInfo.iscontract)"
              ></span> </el-tag
          ></el-descriptions-item>
          <el-descriptions-item label="账期"
            ><el-tag v-if="customerInfo.isaccount" round type="danger" disable-transitions
              ><span
                v-text="util.supplierAccount(customerInfo.isaccount)"
              ></span> </el-tag
          ></el-descriptions-item>
          <el-descriptions-item label="开票税点">{{
            customerInfo.taxpoint
          }}</el-descriptions-item>
          <!-- <el-descriptions-item label="授权文件">
            <el-link v-if="customerInfo.attachment" @click="doDownload" :underline="false" type="danger"><el-icon class="iconcolor" ><Download/></el-icon>下载</el-link>
          </el-descriptions-item> -->



        </el-descriptions>
        <el-divider />
  
        <el-descriptions title="客户商品类目信息" :column="2">
          <el-descriptions-item v-for="item in customerCatalogs" :key="item">
            <el-tag round type="success" disable-transitions
              ><span v-text="item"></span
            ></el-tag>
          </el-descriptions-item>
        </el-descriptions>
        <el-divider />
  
        <el-descriptions title="客户商品品牌信息">
          <el-descriptions-item v-for="item in customerBrand" :key="item">
            <el-tag round type="warning" disable-transitions
              ><span v-text="item"></span
            ></el-tag>
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
    </el-row>
  </template>
  <script setup>
  import { useRouter } from "vue-router";
  import { ref, onMounted } from "vue";
  import { getCustomerInfo } from "@/api/customer";
  // import { download } from "@/api/common";
  import util from "@/util/tool.js";
  
  const router = useRouter();
  
  const customerid = ref(router.currentRoute.value.params.id);
  const title = ref();
  
  // const dictCatalogs = ref([]);
  const customerInfo = ref([]);
  const customerBrand = ref([]);
  const customerCatalog = ref([]);
  const customerCatalogs= ref([]);
  
  //返回
  const goback = () => {
    router.go(-1);
  };

  //文件下载
// const doDownload = ()=>{
//     download({fileName:customerInfo.value.attachment}).then((res)=>{

//         let fileNameArr = (customerInfo.value.attachment).split('.');
//         let fileName = customerInfo.value.name+'-授权文件.'+fileNameArr[1];
//         const blob = new Blob([res.data]);
//         const elink = document.createElement('a');
//         elink.download = fileName;
//         elink.style.display = 'none';
//         elink.href = URL.createObjectURL(blob);
//         document.body.appendChild(elink);
//         elink.click();
//         URL.revokeObjectURL(elink.href);// 释放URL 对象
//         document.body.removeChild(elink);
//     })
// }
  
  //onMounted方法
  onMounted(() => {
    //getListCatalog();
  
    //详情
    getCustomerInfo({ customerid: customerid.value }).then((res) => {
      customerInfo.value = JSON.parse(res.data.extend.customers.customer[0])
      customerBrand.value = res.data.extend.customers.brands
      customerCatalog.value = res.data.extend.customers.catalogids
      customerCatalogs.value =   res.data.extend.customers.catalogsTmp
      title.value = customerInfo.value.name
    });
  });
  
  // const getListCatalog = () => {
  //   listCatalog({ pageNo: 1, pageSize: 1000 }).then((res) => {
  //     dictCatalogs.value = catalogReset(res.data.extend.pages.list);
  
  //     let tmpCatalog = customerCatalog.value;
  //     let tmpData = []
  //     tmpCatalog.forEach((item) => {
  //         let tmp = findP(item, dictCatalogs.value)
  //         tmpData.push(tmp.join(' > '))
  //     });
  
  //     customerCatalogs.value = tmpData
  //     console.log(tmpData);
  //   });
  // };
  
  // const catalogReset = (catalogs) => {
  //   let dataTmp = [];
  //   catalogs.forEach((catalog) => {
  //     // console.log(depart);
  //     catalog.catalogid = catalog.catalogid.toString();
  //     catalog.parentid = catalog.parentid.toString();
  //     dataTmp.push(catalog);
  //     catalogReset(catalog.children);
  //   });
  //   return dataTmp;
  // };
  
  // const findP = (id, list = [], result = []) => {
  //   for (let i = 0; i < list.length; i += 1) {
  //     // console.log("*******", list[i].catalogid, "********");
  //     const item = list[i];
  //     // 找到目标
  //     if (item.catalogid === id) {
  //     //   console.log("找到了");
  //       // 加入到结果中
  //       result.push(item.name);
  //       // 因为可能在第一层就找到了结果，直接返回当前结果
  //       if (result.length === 1) return result;
  //       return true;
  //     }
  //     // 如果存在下级节点，则继续遍历
  //     if (item.children) {
  //       // 预设本次是需要的节点并加入到最终结果result中
  //       result.push(item.name);
  //       const find = findP(id, item.children, result);
  //       // 如果不是false则表示找到了，直接return，结束递归
  //       if (find) {
  //         return result;
  //       }
  //       // 到这里，意味着本次并不是需要的节点，则在result中移除
  //       result.pop();
  //     }
  //   }
  //   // 如果都走到这儿了，也就是本轮遍历children没找到，将此次标记为false
  //   return false;
  // };
  </script>